import { Route, Routes } from 'react-router-dom';
import { TrendyolOrdersPage } from './TrendyolOrdersPage';
import { CollectOrderPage } from '../Order/CollectOrderPage/CollectOrderPage';
import { ScanTrendyolOrderBarcodePage } from './ScanTrendyolOrderBarcodePage';

export const TrendyolOrdersPageRoot = () => (
  <Routes>
    <Route
      path='/:orderID/collect'
      element={<CollectOrderPage platform='trendyol' />}
    />
    <Route path='/scan' element={<ScanTrendyolOrderBarcodePage />} />
    <Route path='*' element={<TrendyolOrdersPage />} />
  </Routes>
);
